import { useEffect } from "react";
import "./Modal.css";
import contact from "../../assets/contact.jpg";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faMobileScreenButton } from "@fortawesome/free-solid-svg-icons";

const Modal = ({ show, setShow }) => {
  useEffect(() => {
    document.body.classList.toggle("active-modal", show);
    document.body.classList.toggle("disable-animations", show);
    return () => {
      document.body.classList.remove("active-modal");
      document.body.classList.remove("disable-animations");
    };
  }, [show]);

  if (!show) return null;

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title">
      <div onClick={() => setShow(false)} className="overlay" />
      <div className="modal-content-m">
        <div className="container p-5 my-auto">
          <div className="row justify-content-center position-m">
            <div className="col-lg-8">
              <div className="card shadow-lg">
                <Image src={contact} className="img-m" alt="Contacto VPEX" />
                <button type="button" className="btn-close" aria-label="Cerrar" onClick={() => setShow(false)} style={{ position: "absolute", top: "1rem", right: "1rem", zIndex: 999 }} />
                <div className="card-body p-4 form-m">
                  <div className="text-center bck-title-m">
                    <div id="contact-modal-title" className="fs-2 fw-light text-dark">Contacto</div>
                    <p className="text-dark fs-6 mb-m">Escribinos por WhatsApp, correo electrónico o llamanos.</p>
                    <div className="d-flex align-items-center justify-content-center">
                      <a href="https://wa.me/59899447449" target="_blank" rel="noreferrer" className="icons-m fs-2" aria-label="WhatsApp"><FontAwesomeIcon icon={faWhatsapp} /></a>
                      <a href="mailto:valvarez@vpex.com.uy" className="icons-m fs-2" aria-label="Correo electrónico"><FontAwesomeIcon icon={faEnvelope} /></a>
                      <a href="tel:+59899447449" className="icons-m fs-2" aria-label="Teléfono"><FontAwesomeIcon icon={faMobileScreenButton} /></a>
                    </div>
                    <p className="mt-3 mb-0 text-dark">+598 99 447 449 · valvarez@vpex.com.uy</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
